import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { NumberOnlyDirective } from '../core/directives/number.directive';
import { NgxEditorModule } from 'ngx-editor';
import { MultiColumnSelectComponent } from './components/multi-column-select/multi-column-select.component';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';

@NgModule({
  declarations: [NumberOnlyDirective,SafeHtmlPipe],
  imports: [CommonModule, RouterModule, ReactiveFormsModule,NgxEditorModule,MultiColumnSelectComponent],
  exports: [NumberOnlyDirective,NgxEditorModule,MultiColumnSelectComponent,SafeHtmlPipe]
})
export class SharedModule {}
